import React from 'react'

const Support = ({ fill = 'currentColor' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 10.5C13.38 10.5 14.5 11.62 14.5 13C14.5 14.38 13.38 15.5 12 15.5C10.62 15.5 9.5 14.38 9.5 13C9.5 11.62 10.62 10.5 12 10.5ZM7 18.5C7 16.01 9.24 14 12 14C14.76 14 17 16.01 17 18.5V20H7V18.5ZM19 9C20.1 9 21 9.9 21 11C21 12.1 20.1 13 19 13C17.9 13 17 12.1 17 11C17 9.9 17.9 9 19 9ZM5 9C6.1 9 7 9.9 7 11C7 12.1 6.1 13 5 13C3.9 13 3 12.1 3 11C3 9.9 3.9 9 5 9Z"
        fill={fill}
      />
    </svg>
  )
}

export default Support
